import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from "../Common/Loading";

// Import all images
import loginBg from "./Image/login_bg2.jpg";
import barTitle from "./Image/bar_titles_log_in.png";
import loginLogoLrg from "./Image/login_logo_lrg.png";
import userIdIcon from "./Image/fr_userid.png";
import passwordIcon from "./Image/fr_password.png";
import showHideIcon from "./Image/show_hide_password_icon.png";
import loginLogoSml from "./Image/login_logo_lrg.png";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const EL_Functions = {
  ShowMessage: (message: string, type: string = 'A'): void => {
    if (type === 'A') {
      alert(message);
    } else {
      console.error(message);
    }
  }
};

const SupportLogin: React.FC = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const passwordInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  // Styles object with all inline styles
  const styles = {
    supportLoginContainer: {
      width: '100%',
      minHeight: '100vh',
      background: `url(${loginBg}) no-repeat center center fixed`,
      backgroundSize: 'cover',
      fontFamily: "'Open Sans', sans-serif",
      position: 'relative' as const,
      overflowX: 'hidden' as const
    },

    mainTopContainer: {
      width: '100%',
      position: 'relative' as const,
      zIndex: 1
    },

    header: {
      height: '40px',
      top: 0,
      width: '100vw',
      zIndex: 99999,
      position: 'fixed' as const,
      backgroundColor: '#333333',
      display: 'block',
      padding: 0,
      transition: 'all 0.4s ease'
    },

    loginTitleBar: {
      marginTop: '40px',
      height: '80px',
      backgroundColor: '#0d2346',
      width: '100%',
      backgroundImage: `url(${barTitle})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      marginLeft: 'auto',
      marginRight: 'auto'
    } as React.CSSProperties,

    sectionContainer: {
      margin: '0 auto',
      height: 'auto',
      width: '80%',
      display: 'block' as const,
      clear: 'both' as const,
      padding: 0,
      overflow: 'hidden' as const
    } as React.CSSProperties,

    barSection: {
      margin: '0 auto',
      padding: 0,
      height: '100%',
      overflow: 'hidden' as const
    } as React.CSSProperties,

    btLogin: {
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      padding: 0,
      backgroundImage: `url(${barTitle})`,
      height: '100%'
    } as React.CSSProperties,

    loginLogo: {
      height: '200px',
      width: '400px',
      display: 'block' as const,
      margin: '40px auto',
      marginBottom: 0,
      backgroundImage: `url(${loginLogoLrg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'
    } as React.CSSProperties,

    loginFormBox: {
      width: '100%',
      height: '150px',
      display: 'table' as const,
      padding: 0,
      textAlign: 'center' as const,
      marginTop: '20px'
    } as React.CSSProperties,

    buttonBox: {
      width: '100%',
      height: 'auto',
      display: 'table' as const,
      padding: 0,
      textAlign: 'center' as const,
      marginTop: 0
    } as React.CSSProperties,

    // Form elements
    loginField: {
      margin: '0 auto',
      transition: 'all 0.30s ease-in-out',
      outline: 'none' as const,
      boxSizing: 'border-box' as const,
      background: '#FCFCFC',
      marginBottom: '20px',
      border: '1px solid #ccc',
      padding: '25px',
      display: 'inline-block' as const,
      fontSize: '18px',
      textAlign: 'left' as const,
      color: '#535353',
      width: '38%',
      WebkitBoxSizing: 'border-box' as const,
      MozBoxSizing: 'border-box' as const
    } as React.CSSProperties,

    loginUserId: {
      paddingLeft: '55px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '30px 50%',
      backgroundImage: `url(${userIdIcon})`
    } as React.CSSProperties,

    loginPassword: {
      paddingLeft: '55px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '30px 50%',
      backgroundImage: `url(${passwordIcon})`
    } as React.CSSProperties,

    divider: {
      height: '1px',
      width: '100%',
      display: 'block' as const
    } as React.CSSProperties,

    alertText: {
      textAlign: 'center' as const,
      margin: '0 auto',
      marginBottom: 0,
      fontSize: '15px',
      color: '#FFF',
      width: '100%'
    } as React.CSSProperties,

    flash: {
      color: '#ff6b6b',
      fontWeight: 'bold' as const
    } as React.CSSProperties,

    pageTextSml: {
      textAlign: 'center' as const,
      marginTop: 0,
      fontSize: '16px',
      color: '#FFF'
    } as React.CSSProperties,

    // Button styles
    generalBtn: {
      height: '80px',
      width: '99%',
      display: 'inline-table' as const,
      border: 'none',
      backgroundColor: '#F60',
      padding: 0,
      boxShadow: '0px 2px 2px 2px rgba(0,0,0,0.15)',
      margin: '30px auto',
      marginBottom: '30px',
      cursor: 'pointer' as const
    } as React.CSSProperties,

    btnText: {
      textDecoration: 'none' as const,
      outline: 'none' as const,
      padding: '0 15px',
      margin: 0,
      height: '100%',
      width: '100%',
      fontSize: '20px',
      fontWeight: 'bold' as const,
      color: '#FFF',
      textAlign: 'center' as const,
      display: 'table-cell' as const,
      verticalAlign: 'middle' as const,
      background: 'none',
      border: 'none',
      cursor: 'pointer' as const
    } as React.CSSProperties,

    twoBtn: {
      width: '38%'
    } as React.CSSProperties,

    passwordIconContainer: {
      height: '1px',
      width: '1px',
      zIndex: 99,
      display: 'inline-block' as const,
      backgroundColor: 'green'
    } as React.CSSProperties,

    showHidePasswordIcon: {
      height: '25px',
      width: '25px',
      display: 'block' as const,
      position: 'relative' as const,
      zIndex: 50,
      top: '-20px',
      left: '-50px',
      cursor: 'pointer' as const,
      backgroundImage: `url(${showHideIcon})`,
      backgroundSize: '100%',
      backgroundPosition: 'center top'
    } as React.CSSProperties,

    togglePassword: {
      backgroundPosition: 'center bottom'
    } as React.CSSProperties,

    tooltipText: {
      visibility: 'hidden' as const,
      width: '100px',
      backgroundColor: '#494949',
      color: '#fff',
      fontSize: '11px',
      textAlign: 'center' as const,
      borderRadius: '2px',
      paddingTop: '8px',
      paddingBottom: '8px',
      position: 'absolute' as const,
      zIndex: 99,
      top: '110%',
      left: '50%',
      marginLeft: '-50px',
      opacity: 0,
      transition: 'opacity 1s'
    } as React.CSSProperties,

    // Responsive styles
    loginFieldResponsive: {
      marginBottom: '15px',
      padding: '15px',
      fontSize: '13px',
      width: '40%',
      paddingLeft: '30px'
    } as React.CSSProperties,

    loginUserIdResponsive: {
      paddingLeft: '45px',
      backgroundPosition: '20px 49%'
    } as React.CSSProperties,

    generalBtnResponsive: {
      height: '80px',
      marginTop: '20px',
      marginBottom: '20px'
    } as React.CSSProperties,

    twoBtnResponsive: {
      width: '40%'
    } as React.CSSProperties,

    loginLogoResponsive: {
      height: '150px',
      width: '100%',
      backgroundPosition: 'center'
    } as React.CSSProperties,

    loginLogoSmall: {
      height: '100px',
      backgroundImage: `url(${loginLogoSml})`
    } as React.CSSProperties,

    loginLogoHidden: {
      display: 'none' as const
    } as React.CSSProperties,

    passwordIconResponsive: {
      top: '-16px',
      left: '-35px'
    } as React.CSSProperties
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    // Debug: Check what we're sending
    console.log('Login ID:', loginId, 'Password:', password);

    if (!loginId.trim() || !password.trim()) {
      setErrorMessage('Please enter your login ID and password');
      return;
    }

    setIsLoading(true);

    try {
      // Fixed URL - added missing slash
      const response = await fetch(`${API_BASE_URL}api/support/login/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login_id: loginId.trim(),
          password: password.trim()
        })
      });

      const data = await response.json();
      console.log('Response data:', data); // Debug response

      if (data.success) {

        sessionStorage.setItem('login', data.login);
        sessionStorage.setItem('category', data.category);
        sessionStorage.setItem('school_code', data.school_code);
        sessionStorage.setItem('family_code', data.family_code);
        sessionStorage.setItem('country', data.country);

        console.log("Stored session:", {
          login: data.login,
          category: data.category,
          school_code: data.school_code,
          family_code: data.family_code,
          country: data.country
        });

        navigate(data.redirect_url);

      } else {
        setErrorMessage(data.error || 'Login failed');
        // Only clear fields if the error is about invalid credentials
        if (data.error === 'Username or Password is incorrect') {
          setLoginId('');
          setPassword('');
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage('An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    if (passwordInputRef.current) {
      passwordInputRef.current.focus();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin(e);
    }
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getLoginFieldStyle = () => {
    if (windowSize.width <= 1400) {
      return { ...styles.loginField, ...styles.loginFieldResponsive };
    }
    return styles.loginField;
  };

  const getLoginUserIdStyle = () => {
    if (windowSize.width <= 1400) {
      return { ...styles.loginUserId, ...styles.loginUserIdResponsive };
    }
    return styles.loginUserId;
  };

  const getLoginPasswordStyle = () => {
    if (windowSize.width <= 1400) {
      return { ...styles.loginPassword, ...styles.loginUserIdResponsive };
    }
    return styles.loginPassword;
  };

  const getGeneralBtnStyle = () => {
    if (windowSize.width <= 1400) {
      return { ...styles.generalBtn, ...styles.generalBtnResponsive };
    }
    return styles.generalBtn;
  };

  const getTwoBtnStyle = () => {
    if (windowSize.width <= 1400) {
      return styles.twoBtnResponsive;
    }
    return styles.twoBtn;
  };

  const getLoginLogoStyle = () => {
    if (windowSize.width <= 1400) {
      return { ...styles.loginLogo, ...styles.loginLogoResponsive };
    }
    if (windowSize.width <= 425) {
      return { ...styles.loginLogo, ...styles.loginLogoSmall };
    }
    if (windowSize.width <= 375) {
      return { ...styles.loginLogo, ...styles.loginLogoHidden };
    }
    return styles.loginLogo;
  };

  const getPasswordIconStyle = () => {
    if (windowSize.width <= 600) {
      return { ...styles.showHidePasswordIcon, ...styles.passwordIconResponsive };
    }
    return styles.showHidePasswordIcon;
  };

  return (
    <div style={styles.supportLoginContainer}>
      {isLoading && <Loading />}

      <div style={styles.mainTopContainer}>
        <div style={styles.header}></div>
        <div style={styles.loginTitleBar}>
          <div style={styles.barSection}>
            <p style={styles.btLogin}></p>
          </div>
        </div>
      </div>

      <div style={styles.sectionContainer}>
        <div style={getLoginLogoStyle()}></div>

        <form onSubmit={handleLogin}>
          <div style={styles.loginFormBox}>
            <input
              type="text"
              style={{ ...getLoginFieldStyle(), ...getLoginUserIdStyle() }}
              name="login_id"
              placeholder="Login ID"
              maxLength={50}
              tabIndex={1}
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              autoComplete="username"
            />

            <div style={styles.divider}></div>

            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                style={{ ...getLoginFieldStyle(), ...getLoginPasswordStyle() }}
                name="password"
                placeholder="Password"
                maxLength={50}
                tabIndex={2}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                ref={passwordInputRef}
                autoComplete="current-password"
              />

              <span style={styles.passwordIconContainer}>
                <span
                  className="show_hide_password_icon"
                  style={{
                    ...getPasswordIconStyle(),
                    ...(showPassword ? styles.togglePassword : {})
                  }}
                  onClick={togglePasswordVisibility}
                >
                  <span style={styles.tooltipText}>
                    {showPassword ? 'Hide password' : 'Show password'}
                  </span>
                </span>
              </span>
            </div>
          </div>

          <p style={styles.alertText}>
            <span style={styles.flash}>
              {errorMessage && <>&nbsp;{errorMessage}</>}
            </span>
          </p>

          <div style={styles.buttonBox}>
            <div style={{ ...styles.generalBtn, ...getGeneralBtnStyle(), ...getTwoBtnStyle() }}>
              <button
                type="submit"
                disabled={isLoading}
                style={styles.btnText}
              >
                {isLoading ? 'Logging in...' : 'Log In'}
              </button>
            </div>
          </div>

          <p style={styles.pageTextSml}>
            <span style={{ display: 'block', height: '12px', width: '100%' }}></span>
          </p>
        </form>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .show_hide_password_icon:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
          }
        `}
      </style>
    </div>
  );
};

export default SupportLogin;